import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Updates", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "empty" }, "You dont have any notifications yet", -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

import { useDialogStore } from '@/stores/dialogs';
import { CSSProperties, ref, shallowRef } from 'vue';
import Notifications from './dialogs/Notifications.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Notifications',
  setup(__props, { expose }) {

const opened = ref(false)
let el: HTMLElement | null = null

const style = shallowRef<CSSProperties>({})
const dialogStore = useDialogStore()

expose({
  open(e: MouseEvent) {
    if (window.innerWidth < 600) {
      return dialogStore.open(Notifications)
    }
    opened.value = true
    el = e.currentTarget as HTMLElement
    const rect = el.getBoundingClientRect()
    style.value = {
      top: rect.top + rect.height + "px",
      right: window.innerWidth - rect.width - rect.left + "px"
    }
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { duration: 200 }, {
    default: _withCtx(() => [
      (opened.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "notifications-backdrop",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (opened.value = false), ["self"]))
          }, [
            _createElementVNode("div", {
              class: "notifications-container",
              style: _normalizeStyle(_unref(style))
            }, _hoisted_3, 4)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})